export const LOGIN_HINT_OPTIONS = [
    {
        title: 'E-mail',
        value: 'email'
    },
    {
        title: 'User Principal Name',
        value: 'upn'
    },
    {
        title: 'None',
        value: 'none'
    }
];

export const LOGIN_HINT_MEANINGFUL_VALUES = ['email', 'upn'];
